import { TTransaction, WaiveType } from "../../services/transactions/transaction.service";

const HALF_DOLLAR_MAX_AMOUNT = 0.5;
const MONEY_EPSILON = 0.000001;

const isValidMoneyAmount = (value: unknown): value is number => {
  return typeof value === "number" && Number.isFinite(value) && value >= 0;
};

const isAbsent = (value: unknown): boolean => value === undefined || value === null;

const getIdlingAmount = (transaction: TTransaction): number => {
  if (!isAbsent(transaction.idling_fee_with_gst) && !isValidMoneyAmount(transaction.idling_fee_with_gst)) {
    return Number.NaN;
  }

  if (isAbsent(transaction.idling_fee_with_gst) && !isAbsent(transaction.idling_fee) && !isValidMoneyAmount(transaction.idling_fee)) {
    return Number.NaN;
  }

  if (isValidMoneyAmount(transaction.idling_fee_with_gst) && transaction.idling_fee_with_gst > 0) {
    return transaction.idling_fee_with_gst;
  }

  if (isAbsent(transaction.idling_fee_with_gst) && isValidMoneyAmount(transaction.idling_fee) && transaction.idling_fee > 0) {
    return transaction.idling_fee;
  }

  return 0;
};

export const canShowWaiveTransactionAction = (transaction: TTransaction): boolean => {
  if (
    transaction.type !== "fee_charging" ||
    transaction.status !== "Failed" ||
    transaction.is_paid !== false ||
    transaction.is_waived === true ||
    !isValidMoneyAmount(transaction.amount)
  ) {
    return false;
  }

  const idlingAmount = getIdlingAmount(transaction);

  if (!Number.isFinite(idlingAmount)) {
    return false;
  }

  if (idlingAmount > 0) {
    return transaction.amount - idlingAmount >= -MONEY_EPSILON;
  }

  return transaction.amount <= HALF_DOLLAR_MAX_AMOUNT;
};

export const getTransactionWaiverSuccessMessage = (waiveType: WaiveType): string => {
  switch (waiveType) {
    case "half_dollar":
      return "Half-dollar transaction waiver completed successfully.";
    case "idle_fee":
      return "Idle fee waiver completed successfully. The remaining charging amount is still unpaid.";
    case "whole_transaction":
      return "Idle fee and half-dollar transaction waiver completed successfully.";
    default:
      return "Transaction waiver completed successfully.";
  }
};
